import { Expandable } from '@fabric-ds/react';
import { useState } from 'react';
import defaultFaqs from '~/data/faq.json';

type FaqData = {
    question: string;
    answer: string[];
};

type Props = {
    faqs?: FaqData[];
};

export function Faq({ faqs = defaultFaqs }: Props) {
    const half = Math.ceil(faqs.length / 2);

    const colOne = faqs.slice(0, half);
    const colTwo = faqs.slice(half);
    return (
        <div className="flex w-full flex-col gap-24 md:flex-row">
            <div className="flex w-full flex-col gap-24">
                {colOne.map((faq, index) => (
                    <FaqItem key={index} faq={faq} />
                ))}
            </div>
            <div className="flex w-full flex-col gap-24">
                {colTwo.map((faq, index) => (
                    <FaqItem key={index} faq={faq} />
                ))}
            </div>
        </div>
    );
}

type FaqItemProps = {
    faq: FaqData;
};
function FaqItem({ faq }: FaqItemProps) {
    const [expanded, setExpanded] = useState(false);
    return (
        <Expandable
            title={
                <>
                    <span className="my-auto pr-16 font-bold md:pr-56">{faq.question}</span>
                    <div
                        className="box-chevron bg-blue-alt-900 transform self-center rounded-full border border-transparent p-6 transition-transform duration-500 hover:border-green-400 focus:border-green-400 active:border-green-400 group-hover:border-green-400 group-focus:border-green-400 md:border-2 md:p-14"
                        style={{
                            transform: expanded ? 'rotate(225deg)' : 'rotate(0deg)',
                        }}>
                        <svg
                            className="h-12 w-12 md:h-auto md:w-auto"
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 9L17 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M9 1L9 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                </>
            }
            info
            box
            animated
            chevron={false}
            className="bg-blue-alt-800 md:rounded-32 rounded-16 pr-12 text-left text-14 text-green-100 md:pr-16 md:text-16"
            buttonClass="group text-green-400 py-12 md:py-16 hover:no-underline focus:no-underline hover:text-green-400 focus:text-green-400 active:text-green-400 pl-20 md:pl-32 px-0"
            contentClass="pl-20 md:pl-32 pr-32 md:pr-96 md:pb-32"
            onChange={(state) => setExpanded(state)}>
            {faq.answer.map((p) => (
                <p key={p}>{p}</p>
            ))}
        </Expandable>
    );
}
